import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Header from "../Header/Header.jsx"
import style from "./style.module.css"

const Loading = ({ toggleWebLanguage, webLanguage, toggleTheme, webTheme, webText }) => {
  return(
    <>
      <div className={style.loadingDiv}>
        <CircularProgress color="inherit" />
      </div>
    </>
  );
};

export default Loading;